import Dexie, { type Table } from 'dexie'
import type { SyncStatusType } from '../DTOs/Sync/SyncDtos'

export type OfflineEntity = 'stoppage' | 'loading' | 'diggingPattern' | 'patternBlast' | 'completeShift' | 'geoRehandle'
export type OfflineOperation = 'create' | 'update' | 'delete'

export interface MutationQueueItem {
  id?: number
  clientId: string
  entity: OfflineEntity
  operation: OfflineOperation
  shiftId: number
  entityId?: number
  tempId?: string
  rowVersion?: string
  data?: unknown
  createdAt: number
  retryCount: number
}

export interface QueryCacheEntry {
  key: string
  value: string
}

export interface SyncIssue {
  id?: number
  clientId: string
  entity: OfflineEntity
  operation: OfflineOperation
  status: SyncStatusType
  entityId?: number
  shiftId?: number
  serverState?: unknown
  clientData?: unknown
  createdAt: number
}

export class OfflineDb extends Dexie {
  mutationQueue!: Table<MutationQueueItem, number>
  queryCache!: Table<QueryCacheEntry, string>
  syncIssues!: Table<SyncIssue, number>

  constructor() {
    super('eclipseMiningwareOffline')
    this.version(1).stores({
      mutationQueue: '++id, clientId, entity, entityId, tempId, [entity+entityId], [entity+tempId], createdAt',
      queryCache: 'key',
    })
    this.version(2).stores({
      syncIssues: '++id, clientId, status, entity, createdAt',
    })
  }
}

export const offlineDb = new OfflineDb()
